import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToTop } from './scrollUtils';

export function ScrollToTopHelper() {
	const { pathname } = useLocation();

	useEffect(() => {
		setTimeout(scrollToTop, 100);
	}, [pathname]);

	return null;
}
